import api from "../client.ts";

type UserType = {
  id: number;
  email: string;
  password: string;
  token: string;
  personnel_id: number;
  status: number;
  created_at: string;       // ou Date si parsé
  updated_at: string | null;
  role_id: number;
};

const getAll = async ():Promise<{size:number, data: UserType[]}> => {
  const { data } = await api.get("/user/readAll");
  return data;
};

const create = async (newUser:any) => {
  const { data } = await api.post("/user/create", newUser);
  return data;
};

const desactivate = async (id:any) => {
  const { data } = await api.get(`/user/desactive?id=${id}`);
  return data;
};

const activate = async (id:any) => {
  const { data } = await api.get(`/user/active?id=${id}`);
  return data;
};

const update = async (id:any, newUser:any) => {
  const { data } = await api.put(`/user/update?id=${id}`, newUser);
  return data;
};
const updatePassword = async (id:any, newUser:any) => {
  const { data } = await api.put(`/user/updatePassword?id=${id}`, newUser);
  return data;
};


//role_permission
const getRoleAndPermission = async () => {
  const { data } = await api.post("/role_permission/readAll");
  return data;
};
//roles
const getRoles = async () => {
  const { data } = await api.post("/role/readAll");
  return data;
};
//Permissions
const getPermissions = async () => {
  const { data } = await api.post("/permission/readAll");
  return data;
};

export const userController = {getAll, create, desactivate, activate, update, updatePassword,getRoles,getRoleAndPermission,getPermissions};
export type {UserType};